<template>
  <v-card height="100%" hover>
    <v-flex v-if="edit">
      <v-form
        ref="form"
        lazy-validation
      >
        <v-card-title class="subheading font-weight-bold">
          <v-flex>
          <v-text-field
            label="Field Name"
            single-line
            v-model="data_items.fieldName"
            required
            :rules="requiredRules"
          ></v-text-field>
          </v-flex>
          <v-flex>
          <v-layout
            align-center
            justify-end
          >
            <v-icon
              class="mr-1"
              @click="deleteThis">close
            </v-icon>
            <v-icon
              class="mr-1"
              @click="saveThis">save
            </v-icon>
          </v-layout>
          </v-flex>
        </v-card-title>

        <v-divider></v-divider>
        <v-list dense>
          <v-list-tile>
            <v-flex xs3>
              <v-list-tile-content>Description:</v-list-tile-content>
            </v-flex>
            <v-flex xs9>
              <v-text-field
                label="Description"
                single-line
                v-model="data_items.description"
                required
                :rules="requiredRules"
              ></v-text-field>
            </v-flex>
          </v-list-tile>

          <v-list-tile>
            <v-flex xs3>
              <v-list-tile-content>Service:</v-list-tile-content>
            </v-flex>
            <v-flex xs9>
              <v-text-field
                label="Service"
                single-line
                v-model="data_items.service"
                required
                :rules="requiredRules"
              ></v-text-field>
            </v-flex>
          </v-list-tile>

          <v-list-tile>
            <v-flex xs3>
              <v-list-tile-content>Type:</v-list-tile-content>
            </v-flex>
            <v-flex xs9>
              <v-select
                v-model="data_items.type"
                :items="types"
                label="Type"
                single-line
                required
                :rules="requiredRules"
              ></v-select>
            </v-flex>
          </v-list-tile>

          <v-flex v-if="data_items.type === 'string'">
            <v-list-tile>
              <v-flex xs3>
                <v-list-tile-content>Values:</v-list-tile-content>
              </v-flex>
              <v-flex xs9>
                <v-list-tile-content class="align-end">
                  <v-combobox
                    v-model="data_items.values"
                    multiple
                    small-chips
                    deletable-chips
                    hide-no-data
                    single-line
                    clearable
                    v-bind:allow-overflow="false"
                    label="type possible values here"
                  >
                  </v-combobox>
                </v-list-tile-content>
              </v-flex>
            </v-list-tile>
          </v-flex>

          <v-flex v-else-if="data_items.type === 'scale'">
            <v-list-tile>
              <v-flex xs3>
                <v-list-tile-content>Interval:</v-list-tile-content>
              </v-flex>
              <v-flex xs9>
                <v-list-tile-content class="align-end">
                  <v-text-field
                    v-model="data_items.scale"
                    label="Scale [min-max]"
                    single-line
                    :mask="scaleMask"
                    return-masked-value
                    required
                    :rules="requiredRules"
                  ></v-text-field>
                </v-list-tile-content>
              </v-flex>
            </v-list-tile>
          </v-flex>
        </v-list>
      </v-form>
    </v-flex>

    <v-flex v-else @dblclick="editThis">
      <v-card-title class="subheading font-weight-bold">{{data_items.fieldName}}
        <v-layout
          align-center
          justify-end
        >
          <v-icon
            class="mr-1"
            @click="editThis">edit
          </v-icon>
        </v-layout>
      </v-card-title>

      <v-divider></v-divider>

      <v-list dense>
        <v-list-tile>
          <v-list-tile-content>Description:</v-list-tile-content>
          <v-list-tile-content class="align-end">{{data_items.description}}</v-list-tile-content>
        </v-list-tile>

        <v-list-tile>
          <v-list-tile-content>Service:</v-list-tile-content>
          <v-list-tile-content class="align-end">{{data_items.service}}</v-list-tile-content>
        </v-list-tile>

        <v-list-tile>
          <v-list-tile-content>Type:</v-list-tile-content>
          <v-list-tile-content class="align-end">{{data_items.type}}</v-list-tile-content>
        </v-list-tile>

        <v-flex v-if="data_items.type === 'string'">
          <v-list-tile>
            <v-list-tile-content>Values:</v-list-tile-content>
            <v-list-tile-content class="align-end">
              {{this.valuesArray}}
            </v-list-tile-content>
          </v-list-tile>
        </v-flex>

        <v-flex v-else-if="data_items.type === 'scale'">
          <v-list-tile>
            <v-list-tile-content>Interval:</v-list-tile-content>
            <v-list-tile-content class="align-end">{{data_items.scale}}</v-list-tile-content>
          </v-list-tile>
        </v-flex>
        <v-flex v-else-if="data_items.type === 'boolean'">
          <v-list-tile>
            <v-list-tile-content>Values:</v-list-tile-content>
            <v-list-tile-content class="align-end">true, false</v-list-tile-content>
          </v-list-tile>
        </v-flex>
        <v-flex v-else>
          <v-list-tile>
            <v-list-tile-content>Values:</v-list-tile-content>
            <v-list-tile-content class="align-end"></v-list-tile-content>
          </v-list-tile>
        </v-flex>
      </v-list>
    </v-flex>
  </v-card>
</template>

<script>
  import {db} from '../../firebaseDB'

  export default {
    name: 'userClassCard',
    data: () => ({
      edit: (this.id === null),
      scaleMask: '[#-#]',
      types: ['string', 'scale', 'boolean'],
      sections: ['social media', 'personality', 'photo', 'news'],
      requiredRules: [
        v => !!v || 'field cannot be blank'
      ],
      data_items: Object
    }),
    props: {
      id: String,
      section: String
    },
    watch: {
      id (val) {
        this.initialize()
      }
    },
    mounted () {
      this.initialize()
    },
    methods: {
      validate () {
        if (this.$refs.form.validate()) {
          this.snackbar = true
          return true
        }
        return false
      },
      editThis () {
        this.edit = true
      },
      saveThis () {
        if (this.validate()) {
          this.pushToDB()
          this.edit = false
        }
      },
      pushToDB () {
        let updates = {}
        let id = this.id
        if (id === null) { // if key is null, then the data does not pre-exist in db
          id = db.ref(`assets/asset_data/user/data/`).push().key
        }
        updates[`data/${id}`] = this.data_items
        updates[`sections_services/${this.section}/${this.data_items.service.toLowerCase()}/${id}`] = this.data_items.fieldName
        updates[`services/${this.data_items.service.toLowerCase()}/${id}`] = this.data_items.fieldName   // changes to lower case
        return db.ref(`assets/asset_data/user/`).update(updates)
      },
      deleteThis () {
        if (this.id) {
          if (confirm(`Are you sure you want to delete ${this.data_items.fieldName} ?`)) {
            db.ref(`assets/asset_data/user/sections/${this.section}/${this.id}`)
              .set(null)
            db.ref(`assets/asset_data/user/services/${this.data_items.service.toLowerCase()}/${this.id}`)
              .set(null)
          }
        } else {
          this.$emit('deleteNull')
        }
      },
      initialize () {
        this.edit = (this.id === null)
        console.log(this.id)
        console.log(this.section)
        if (this.id) {
          db.ref(`assets/asset_data/user/data/${this.id}`)
            .on('value', (snapshot) => {
              this.data_items = snapshot.val()
            })
        } else {
          this.data_items = {
            section: this.section,
            service: null,
            type: null,
            fieldName: null,
            values: null,
            scale: null,
            description: null
          }
        }
      }
    },
    computed: {
      valuesArray () {
        if (this.data_items.values) {
          return this.data_items.values.join(', ')
        } else {
          return 'None'
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/user-class/userClassCard.vue